export default {
  navigation: {
    next: "Dalej",
    back: "Wstecz",
    surveyNavigation: "Nawigacja ankiety",
    workspace: {
      home: "Strona główna",
      example: "Przykład"
    }
  }
}
